export const getDeviceType = () => {
  const ua = navigator.userAgent.toLowerCase();
  const hasTouchCapability = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 화면의 큰 쪽 치수
  const largerDimension = Math.max(window.innerWidth, window.innerHeight);

  // iPad 감지 (모든 iPad 모델, mini 포함)
  const isIPad =
    /ipad/.test(ua) ||
    (/macintosh/.test(ua) && navigator.maxTouchPoints > 0);

  // 갤럭시 탭 감지
  const isGalaxyTab =
    /sm-t/.test(ua) ||
    /gt-p/.test(ua);

  // 태블릿 키워드 확인
  const hasTabletKeyword =
    /tablet/.test(ua) && !/mobile/.test(ua);

  // 명확한 모바일 패턴 감지
  const isMobilePattern =
    /android.*mobile/.test(ua) ||
    /iphone/.test(ua) ||
    /windows phone/.test(ua);

  // 1. 명시적 디바이스 감지 우선 (User-Agent 기반)
  if (isIPad || isGalaxyTab || hasTabletKeyword) {
    return "tablet";
  }

  if (isMobilePattern) {
    return "mobile";
  }

  // 2. User-Agent로 명확히 구분되지 않는 경우, 화면 크기와 터치 기능으로 판단
  if (hasTouchCapability) {
    // 매우 작은 화면은 무조건 모바일
    if (largerDimension < 700) {
      return "mobile";
    }

    // 매우 큰 화면은 태블릿
    if (largerDimension > 1000) {
      return "tablet";
    }

    // 애매한 영역 (700-1000px) - 추가 조건으로 판단
    // 안드로이드 기기면서 'mobile' 키워드가 있으면 모바일로 판단
    if (/android/.test(ua) && /mobile/.test(ua)) {
      return "mobile";
    }

    // 그 외의 애매한 크기 터치 기기는 태블릿으로 간주
    return "tablet";
  }

  // 터치 기능이 없으면 데스크톱
  return "desktop";
}
